import { convertToKebabCase } from "../../utils/text/text";

export function getStatusClassName(cellValue: string) {
  return convertToKebabCase(cellValue);
}
